/* eslint-disable */
import { defineStore } from 'pinia';
import { useCompetitionsStore } from './competitions';
import { usePlatformConfigurationStore } from './platform_configuration';
import { useDateTimeSportFiltersStore } from './date_time_sport_filters';
import _ from 'lodash';

export const useRegionsStore = defineStore('regions', {
	state: () => ({
		regions_competitions_all: null,
		regions_competitions: null,
		selected_region_id: null,
		dropdown_selector_opened: false,
		regions_order: 'asc',
		regions_order_popularity: 'desc'
	}),
	getters: {
		regionsCompetitions(state) {
			let regions = _.cloneDeep(state.regions_competitions_all);
			for (const key in regions) {
				if (Object.hasOwnProperty.call(regions, key)) {
					regions[key].competitions = _.orderBy(regions[key].competitions, ['weight', 'name'], ['desc', 'asc']);
				}
			}

			return _.orderBy(regions, ['name'], [state.regions_order]);
		},
		regionsCompetitionsPopularity(state) {
			let regions = _.cloneDeep(state.regions_competitions_all);
			for (const key in regions) {
				if (Object.hasOwnProperty.call(regions, key)) {
					regions[key].competitions = _.orderBy(regions[key].competitions, ['weight', 'name'], ['desc', 'asc']);
				}
			}

			return _.orderBy(regions, ['weight', 'name'], [state.regions_order_popularity, 'asc']);
		},
		regionsCompetitionsCoupons(state) {

			const platformConfigurationStore = usePlatformConfigurationStore();
			const dateTimeSportFiltersStore = useDateTimeSportFiltersStore();

			let regions = _.cloneDeep(state.regions_competitions);
			if (dateTimeSportFiltersStore.selected_option == 'all') {
				regions = _.cloneDeep(state.regions_competitions_all);
			} else {
				for (const key in regions) {
					if (Object.hasOwnProperty.call(regions, key)) {
						let all_region = _.find(state.regions_competitions_all, {'id': regions[key].id});
						if (all_region) {
							regions[key].weight = all_region.weight;
						}
					}
				}
			}


			if (platformConfigurationStore.isNewPreSportsLayoutEnabled) {
				regions = _.filter(regions, (region) => {
					return region.pre_fixtures_count > 0;
				});

			}

			for (const key in regions) {
				if (Object.hasOwnProperty.call(regions, key)) {
					let competitions = regions[key].competitions;
					if (platformConfigurationStore.isNewPreSportsLayoutEnabled) {
						competitions = _.filter(regions[key].competitions, (competition) => {
							return competition.pre_fixtures_count > 0;
						});
					}

					regions[key].competitions = _.orderBy(competitions, ['weight', 'name'], ['desc', 'asc']);
				}
			}

			if (!platformConfigurationStore.isNewPreSportsLayoutEnabled) {
				let sorted_regions = _.orderBy(regions, ['weight', 'name'], ['desc', 'asc']);
				return sorted_regions;
			}

			let sorted_regions = _.orderBy(regions, ['weight', 'name'], ['desc', 'asc']);

			const competitonsStore = useCompetitionsStore();
			const top_competitions = _.cloneDeep(competitonsStore.topCompetitionsSport);

			const my_top = [];
			for (const key in top_competitions) {
				let fixtures_count = 0;
				const found_region = _.find(state.regions_competitions, {'id': top_competitions[key].region_id});
				if (found_region && found_region.competitions[top_competitions[key].id]) {
					fixtures_count = found_region.competitions[top_competitions[key].id].fixtures_count
					top_competitions[key].fixtures_count = fixtures_count;
					my_top.push(top_competitions[key]);
				}
			}

			if (top_competitions && top_competitions.length > 0 && my_top.length > 0) {
				const topRegion = {
					id: -1,
					name: 'top_leagues',
					weight: 999999,
					competitions: my_top,
					competitions_count: my_top.length,
					fixtures_count: _.sumBy(my_top, 'fixtures_count'),
					icon: '/images/country-flags/flat/topleagues.svg'
				};

				sorted_regions.unshift(topRegion);
			}

			return sorted_regions;
		},
		selectedRegionId(state) {
			return state.selected_region_id;
		},
		dropdownSelectorOpened(state) {
			return state.dropdown_selector_opened;
		}
	},
	actions: {
		fetchRegions(sport_id) {
			return global.axios.get(process.env.VUE_APP_SPORTSBOOK_API_URL + '/regions/competitions/sport/' + sport_id, { withCredentials: false }).then((response) => {
				this.regions_competitions_all = response.data;
				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error);
			})
		},
		setSelectedRegionId(data) {
			this.selected_region_id = data;
		},
		toggleDropdownSelector() {
			this.dropdown_selector_opened = !this.dropdown_selector_opened;
		},
		setRegionsOrder() {
			if (this.regions_order == 'asc') {
				this.regions_order = 'desc';
				return;
			}

			if (this.regions_order == 'desc') {
				this.regions_order = 'asc';
				return;
			}

		},
		setRegionsPopularityOrder() {
			if (this.regions_order_popularity == 'asc') {
				this.regions_order_popularity = 'desc';
				return;
			}

			if (this.regions_order_popularity == 'desc') {
				this.regions_order_popularity = 'asc';
				return;
			}

		}
	},
})